var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Flag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.49 26.5L65 39H27V14h38L54.49 26.5zM19 5.83A3.17 3.17 0 0015.83 9 3.14 3.14 0 0017 11.44V69h4V11.44A3.14 3.14 0 0022.17 9 3.17 3.17 0 0019 5.83z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Flag.9fd0113c.svg";
export { SvgK1Flag as ReactComponent };